import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateChannelRefreshTable } from "../../../redux/channels/channelSlice";
import validatePermission from "../../../utils/validatePermissions";
// ANT DESIGN COMPONENTS
// INTERFACES
import { RootState } from "../../../app/store";

function ChannelsHeader() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	// LOCAL STORAGE AND VARIABLES ******************** */
	const dispatch = useDispatch();
	const { permissions } = useSelector((state: RootState) => state.user);
	const [t] = useTranslation("global");

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onClickReloadPage = () => {
		dispatch(updateChannelRefreshTable(true));
		setTimeout(() => {
			dispatch(updateChannelRefreshTable(false));
		}, 1000);
	};

	// ************************************************* */
	// USE EFFECT ************************************** */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<div className='generalStyles__pageHeader'>
				{validatePermission("channels-view", permissions) && (
					<div className='generalStyles__mlFix mt-1'>
						<Button
							className='buttonStyle__8'
							icon={<FontAwesomeIcon icon={faArrowsRotate} className='generalStyles__mrFix' />}
							onClick={() => {
								onClickReloadPage();
							}}
						>
							{t("userManagement.refreshTable")}
						</Button>
					</div>
				)}
			</div>
		</div>
	);
}

export default ChannelsHeader;
